import { render, staticRenderFns } from "./InsOverviewCard.vue?vue&type=template&id=c9230b2c"
import script from "./InsOverviewCard.vue?vue&type=script&lang=js"
export * from "./InsOverviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports